import React from 'react';

const SkeletonLoader = ({ type = 'text', count = 1, style = {} }) => {
  const baseStyle = {
    backgroundColor: '#e5e7eb',
    borderRadius: '4px',
    animation: 'pulse 1.5s ease-in-out infinite',
    marginBottom: '12px',
  };

  const types = {
    text: { height: '16px', width: '100%' },
    title: { height: '24px', width: '60%' },
    card: { height: '120px', width: '100%' },
    stat: { height: '80px', width: '100%' },
    dashboard: { height: '200px', width: '100%' },
    table: { height: '400px', width: '100%' },
    detail: { height: '300px', width: '100%' },
  };

  const skeletonStyle = {
    ...baseStyle,
    ...types[type],
    ...style,
  };

  return (
    <>
      <style>
        {`
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
        `}
      </style>
      <div style={{ padding: '20px' }}>
        {Array.from({ length: count }).map((_, index) => (
          <div key={index} style={skeletonStyle} />
        ))}
      </div>
    </>
  );
};

export default SkeletonLoader;
